<template>
    <v-container fluid>
        <v-flex>
            <v-row no-gutters>
                <v-col>
                    <h1>{{ "Code NAF (APE)" }}</h1>
                </v-col>
                <v-spacer />
                <v-col>
                    <v-text-field
                        v-model="search"
                        append-inner-icon="$search"
                        clearable
                        label="Recherche"
                        single-line
                        hide-details
                    />
                </v-col>
            </v-row>
        </v-flex>
        <v-row no-gutters>
            <v-col>
                <v-card class>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        class="table"
                        fixed-header
                        max-height="60vh"
                    >
                        <template v-slot:item="props">
                            <tr
                                @click="
                                    $router.push({
                                        name: `companyactivity-details`,
                                        params: { id: `${props.item.id}` },
                                    })
                                "
                                style="cursor: pointer"
                            >
                                <td class="text-center">{{ props.item.name }}</td>
                                <td class="text-left">{{ props.item.description }}</td>
                                <td class="text-center">
                                    <v-btn class="v-btn-text-white" size="small"> Edition </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script lang="ts">
import { State2Way } from "@/decorators";
import { Apollo } from "@/decorators";

import COMPANY_ACTIVITIES from "../../graphql/CompanyActivities.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";

// import UPDATE_TAG from '../../graphql/UpdateCompanyActivities.gql'

@Component
export class NafTags extends Vue {
    headers: Array<any> = [
        { title: "Nom", value: "name", sortable: false, align: "center" },
        { title: "Description", value: "description", sortable: false, align: "left" },
        { title: "Detail", value: "", sortable: false, align: "center" },
    ];

    search: string = "";

    @Apollo({
        query: COMPANY_ACTIVITIES,
        variables() {
            return {
                search: this.search,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companyActivities) {
                    this.items = data.companyActivities;
                }
            }
        },
        // @ts-ignore
        debounce: 500,
    })
    items: Array<any> = [];
}

export default toNative(NafTags);
</script>
<style scoped>
.v-btn-text-white {
    background-color: rgb(var(--v-theme-green)) !important;
    color: white !important;
}
</style>
